import { Country } from '@grid-ui/common';
import { ItemInformationListingItemDatatype } from '../item-information-listing';

export function isCountry(data: ItemInformationListingItemDatatype): data is Country {
  return (data as Country).geo_id !== undefined && (data as Country).type === 'country';
}
